import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { API_BASE_URL, base_url, profileImgSrc } from "../../../../config";
import { getAdminAuthToken } from "../../../../auth/auth";
import { useParams } from "react-router-dom";
import Loader from "../../../../components/Loader";

export default function AppliedCandidates() {
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [actionLoading, setActionLoading] = useState(false);

  const token = getAdminAuthToken();
  const { id } = useParams();

  // Fetch applied candidates
  const fetchApplied = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/jobs/${id}/applied-candidates`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (!result.success) {
        toast.error(result.message || "Failed to load applied candidates");
        setLoading(false);
        return;
      }

      setList(result.data || []);
    } catch (err) {
      toast.error("Failed to fetch applied candidates");
    }

    setLoading(false);
  };

  // Accept → status = 0
  const handleAccept = async (candidate_id) => {
    if (actionLoading) return;

    setActionLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/jobs/${id}/applied-candidates/${candidate_id}/accept`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (!result.success) {
        toast.error(result.message || "Failed to accept candidate");
        setActionLoading(false);
        return;
      }

      toast.success("Candidate accepted");
      fetchApplied();
    } catch (err) {
      toast.error("Failed to accept candidate");
    }

    setActionLoading(false);
  };

  // Reject → status = 2
  const handleReject = async (candidate_id) => {
    if (actionLoading) return;

    setActionLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_URL}/admin/jobs/${id}/applied-candidates/${candidate_id}/reject`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (!result.success) {
        toast.error(result.message || "Failed to reject candidate");
        setActionLoading(false);
        return;
      }

      toast.success("Candidate rejected");
      fetchApplied();
    } catch (err) {
      toast.error("Failed to reject candidate");
    }

    setActionLoading(false);
  };

  useEffect(() => {
    if (id) fetchApplied();
  }, [id]);

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="add-candidate-dashboard">
        <h3>Applied Candidates</h3>

        {loading ? (
          <Loader />
        ) : list.length === 0 ? (
          <p className="no-candidates">No applied candidates</p>
        ) : (
          <div className="candidates-wrapper">
            {list.map((c) => (
              <div
                key={c.candidate_id}
                className={`candidate-card ${
                  actionLoading ? "blink-disabled" : ""
                }`}
              >
                <div className="candidate-info">
                  <img
                    src={
                      c.avatar
                        ? c.avatar.startsWith("http")
                          ? c.avatar
                          : `${base_url}${c.avatar}`
                        : profileImgSrc
                    }
                    alt={c.name}
                  />
                  <div>
                    <p className="name">{c.name}</p>
                    <p className="email">{c.email}</p>
                  </div>
                </div>

                <div className="candidate-buttons">
                  <div className="candidate-tags">
                    <button
                      className="badge-accept"
                      onClick={() => handleAccept(c.candidate_id)}
                      disabled={actionLoading}
                    >
                      Accept
                    </button>

                    <button
                      className="badge-reject"
                      onClick={() => handleReject(c.candidate_id)}
                      disabled={actionLoading}
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
